import "./logo.scss";
import { linksData, profileData } from "../../data/data"
import { Link } from "react-router-dom";

interface LogoProps {
   name?: string;
   link?: boolean;
   mobile?: boolean
}

function Logo({ name = "", link = false, mobile = false }: LogoProps) {
   let mobile_logo = "",
      mobile_logo_img_wrapper = "",
      mobile_logo_img = "",
      mobile_logo_text = "";
   if (mobile) {
      mobile_logo = "mobile-logo";
      mobile_logo_img_wrapper = "mobile-logo__img-wrapper";
      mobile_logo_img = "mobile-logo__img";
      mobile_logo_text = "mobile-logo__text";
   }

   return (
      <div className={`logo ${mobile_logo}`}>
         {link ?
            <Link className="logo__link" to={linksData[0].url}>
               <div className="logo__img-wrapper">
                  <img className="logo__img" src={profileData.logo} alt="Logo" />
               </div>
               {name.length > 0 && <p className={`logo__text ${mobile_logo_text}`}>{name}</p>}
            </Link> : <>
               <div className={`logo__img-wrapper ${mobile_logo_img_wrapper}`}>
                  <img className={`logo__img ${mobile_logo_img}`} src={profileData.logo} alt="Logo" />
               </div>
               {name.length > 0 && <p className={`logo__text ${mobile_logo_text}`}>{name}</p>}
            </>}
      </div>
   )
}

export default Logo